import React from "react";

const renderMerchantHeaderInfos = (
  displayHeader,
  merchantLibelle,
  mainResortLibelle
) => {
  const merchantInfos =
    mainResortLibelle !== undefined &&
    mainResortLibelle !== null &&
    mainResortLibelle.length > 0
      ? `${merchantLibelle} - ${mainResortLibelle}`
      : merchantLibelle;
  if (displayHeader) {
    return <div className="merchant-infos-title">{merchantInfos}</div>;
  }
};

export { renderMerchantHeaderInfos };



// WEBPACK FOOTER //
// ./src/merchant/utils.js